/**
 * Languages with their own transcription landing page
 * (/ai-transcription/<slug>). The names are English keys in the
 * `ai-transcription` namespace; the picker in the app offers a few more
 * (TRANSCRIPTION_LANGUAGES).
 */
export type TranscriptionLanguagePage = {
  name: string;
  flag: string;
  slug: string;
};

export const TRANSCRIPTION_LANGUAGE_PAGES: TranscriptionLanguagePage[] = [
  { name: 'Arabic', flag: '🇸🇦', slug: 'arabic' },
  { name: 'Bulgarian', flag: '🇧🇬', slug: 'bulgarian' },
  { name: 'Chinese', flag: '🇨🇳', slug: 'chinese' },
  { name: 'Croatian', flag: '🇭🇷', slug: 'croatian' },
  { name: 'Czech', flag: '🇨🇿', slug: 'czech' },
  { name: 'Danish', flag: '🇩🇰', slug: 'danish' },
  { name: 'Dutch', flag: '🇳🇱', slug: 'dutch' },
  { name: 'English', flag: '🇬🇧', slug: 'english' },
  { name: 'Estonian', flag: '🇪🇪', slug: 'estonian' },
  { name: 'Filipino', flag: '🇵🇭', slug: 'filipino' },
  { name: 'Finnish', flag: '🇫🇮', slug: 'finnish' },
  { name: 'French', flag: '🇫🇷', slug: 'french' },
  { name: 'German', flag: '🇩🇪', slug: 'german' },
  { name: 'Greek', flag: '🇬🇷', slug: 'greek' },
  { name: 'Hebrew', flag: '🇮🇱', slug: 'hebrew' },
  { name: 'Hindi', flag: '🇮🇳', slug: 'hindi' },
  { name: 'Hungarian', flag: '🇭🇺', slug: 'hungarian' },
  { name: 'Icelandic', flag: '🇮🇸', slug: 'icelandic' },
  { name: 'Indonesian', flag: '🇮🇩', slug: 'indonesian' },
  { name: 'Italian', flag: '🇮🇹', slug: 'italian' },
  { name: 'Japanese', flag: '🇯🇵', slug: 'japanese' },
  { name: 'Kazakh', flag: '🇰🇿', slug: 'kazakh' },
  { name: 'Korean', flag: '🇰🇷', slug: 'korean' },
  { name: 'Latvian', flag: '🇱🇻', slug: 'latvian' },
  { name: 'Lithuanian', flag: '🇱🇹', slug: 'lithuanian' },
  { name: 'Macedonian', flag: '🇲🇰', slug: 'macedonian' },
  { name: 'Malay', flag: '🇲🇾', slug: 'malay' },
  { name: 'Norwegian', flag: '🇳🇴', slug: 'norwegian' },
  { name: 'Polish', flag: '🇵🇱', slug: 'polish' },
  { name: 'Portuguese', flag: '🇵🇹', slug: 'portuguese' },
  { name: 'Romanian', flag: '🇷🇴', slug: 'romanian' },
  { name: 'Russian', flag: '🇷🇺', slug: 'russian' },
  { name: 'Serbian', flag: '🇷🇸', slug: 'serbian' },
  { name: 'Slovak', flag: '🇸🇰', slug: 'slovak' },
  { name: 'Slovenian', flag: '🇸🇮', slug: 'slovenian' },
  { name: 'Spanish', flag: '🇪🇸', slug: 'spanish' },
  { name: 'Swedish', flag: '🇸🇪', slug: 'swedish' },
  { name: 'Tamil', flag: '🇮🇳', slug: 'tamil' },
  { name: 'Thai', flag: '🇹🇭', slug: 'thai' },
  { name: 'Turkish', flag: '🇹🇷', slug: 'turkish' },
  { name: 'Ukrainian', flag: '🇺🇦', slug: 'ukrainian' },
  { name: 'Vietnamese', flag: '🇻🇳', slug: 'vietnamese' },
];

export const findTranscriptionLanguagePage = (slug: string) =>
  TRANSCRIPTION_LANGUAGE_PAGES.find(
    (language) => language.slug === slug.toLowerCase(),
  );
